import { useState } from "react";
import { useSelector } from "react-redux";

function ContractTab(props) {
  const onClick = () => {
    const { label, onClick } = props;
    onClick(label);
  };

  let className = "tab-list-item";
  const { activeTab, label, disabled } = props;
  if (activeTab === label) {
    className += " tab-list-active";
  }
  if (disabled) {
    className += " disabled";
  }

  return (
    <li className={className} onClick={onClick}>
      {label}
    </li>
  );
}

function ContractTabs(props) {
  const [activeTab, setActiveTab] = useState(props.children[0].props.label);

  const { contract } = useSelector((state) => state.b2bContractsReducer);

  const onClickTabItem = (tab) => {
    setActiveTab(tab);
  };

  const { id } = contract;
  return (
    <div className="contratcs">
      <div className="tabs">
        <ol className="tab-list">
          <div className="tabsContent">
            {props.children.map((child) => {
              const { label } = child.props;
              if (label === "Students" && !id) {
                return (
                  <ContractTab
                    disabled={true}
                    activeTab={activeTab}
                    key={label}
                    label={label}
                    onClick={onClickTabItem}
                  />
                );
              }
              return <ContractTab activeTab={activeTab} key={label} label={label} onClick={onClickTabItem} />;
            })}
          </div>
        </ol>
        <div className="tab-content">
          {props.children.map((child) => {
            if (child.props.label !== activeTab) {
              return undefined;
            }
            return child.props.children;
          })}
        </div>
      </div>
    </div>
  );
}

export default ContractTabs;
